// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TandC {
    width:100%;
    font-family: sans-serif;
    overflow-y: scroll;
    text-align: center;
    transform: scaleX(0.95);
   
    & h3{
        width:98%;
    }
    & ol{
       
        text-align: left;
        
        & li{           
          margin-left: 0px;
          width:92%;
        }
        
      }

     & p{

        text-align: left;
        width:99%;
     }
     & table{
    
      
       margin-left: 15px;
       margin-top: -40px;
       text-align: left;
       border: 1px solid ;
       border-collapse: collapse;
       border-color: #764CBF;      
      
       & th {
           margin-left: 40px;
           text-align: left;
           border: 0px solid;
           background-color: #764CBF;
           color:white;
          padding-left: 5px;
       }
       & tr {
           padding-left: 15px; 
           border: 1px solid;
           border-color: #764CBF;
           background-color: white
           ;
       } 

   }

}

.faq {

    width:90%;
    font-family: sans-serif;
    overflow-y: scroll;
    text-align: left;
    & h1{

        color: #5C2D91;
        font-size: 5vw;
        @media screen and (min-width: 769px)  and (max-width: 999px){
            font-size:1.2rem;
           }
           @media screen and (min-width: 1000px)  and (max-width: 1200px){
            font-size:1.3rem;
           }
          
           @media screen and (min-width: 1201px)  and (max-width: 1580px){
            font-size:1.6rem;
           }
           @media screen and (min-width: 1581px)  {
            font-size:1.7rem;
           }
        
    }
    & h2{

        text-align: left;
        font-size: 4vw;
        @media screen and (min-width: 769px)  and (max-width: 999px){
            font-size:1rem;
           }
           @media screen and (min-width: 1000px)  and (max-width: 1200px){
            font-size:1.2rem;
           }
          
           @media screen and (min-width: 1201px)  and (max-width: 1580px){
            font-size:1.3rem;
           }
           @media screen and (min-width: 1581px)  {
            font-size:1.5rem;
           }
    }
    & p{
        text-align: left;       
        margin-left:0;
      
        @media screen and (min-width: 769px)  and (max-width: 999px){
            font-size:0.9rem;
           }
           @media screen and (min-width: 1000px)  and (max-width: 1200px){
            font-size:1rem;
           }
          
           @media screen and (min-width: 1201px)  and (max-width: 1580px){
            font-size:1.1rem;
           }
           @media screen and (min-width: 1581px)  {
            font-size:1.2rem;
           }
        
    }
    & ul{

        text-align: left;
    }
}

.paia{
    width:90%;
    font-family: sans-serif;
    overflow-y: scroll;
    & h4 {

        color: #764CBF;
    }

    & p {

        margin-left:10px;
        text-align: left;
        
    }
    & table,tr {
     
        border: 1px solid ;
        border-color: #764CBF;
        border-collapse: collapse;
        background-color: white;
        text-align: left;
        width:100%;
        & td{

            border: 1px solid ;
            border-color: #764CBF;
            border-collapse: collapse;
            background-color: white;
            padding-right: 6px;
        }       
    }
    & ul{

        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/pagestyles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;;IAEvB;QACI,SAAS;IACb;IACA;;QAEI,gBAAgB;;QAEhB;UACE,gBAAgB;UAChB,SAAS;QACX;;MAEF;;KAED;;QAEG,gBAAgB;QAChB,SAAS;KACZ;KACA;;;OAGE,iBAAiB;OACjB,iBAAiB;OACjB,gBAAgB;OAChB,kBAAkB;OAClB,yBAAyB;OACzB,qBAAqB;;OAErB;WACI,iBAAiB;WACjB,gBAAgB;WAChB,iBAAiB;WACjB,yBAAyB;WACzB,WAAW;UACZ,iBAAiB;OACpB;OACA;WACI,kBAAkB;WAClB,iBAAiB;WACjB,qBAAqB;WACrB;WACA;OACJ;;GAEJ;;AAEH;;AAEA;;IAEI,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB;;QAEI,cAAc;QACd,cAAc;QACd;YACI,gBAAgB;WACjB;WACA;YACC,gBAAgB;WACjB;;WAEA;YACC,gBAAgB;WACjB;WACA;YACC,gBAAgB;WACjB;;IAEP;IACA;;QAEI,gBAAgB;QAChB,cAAc;QACd;YACI,cAAc;WACf;WACA;YACC,gBAAgB;WACjB;;WAEA;YACC,gBAAgB;WACjB;WACA;YACC,gBAAgB;WACjB;IACP;IACA;QACI,gBAAgB;QAChB,aAAa;;QAEb;YACI,gBAAgB;WACjB;WACA;YACC,cAAc;WACf;;WAEA;YACC,gBAAgB;WACjB;WACA;YACC,gBAAgB;WACjB;;IAEP;IACA;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB;;QAEI,cAAc;IAClB;;IAEA;;QAEI,gBAAgB;QAChB,gBAAgB;;IAEpB;IACA;;QAEI,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,uBAAuB;QACvB,gBAAgB;QAChB,UAAU;QACV;;YAEI,kBAAkB;YAClB,qBAAqB;YACrB,yBAAyB;YACzB,uBAAuB;YACvB,kBAAkB;QACtB;IACJ;IACA;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":[".TandC {\r\n    width:100%;\r\n    font-family: sans-serif;\r\n    overflow-y: scroll;\r\n    text-align: center;\r\n    transform: scaleX(0.95);\r\n   \r\n    & h3{\r\n        width:98%;\r\n    }\r\n    & ol{\r\n       \r\n        text-align: left;\r\n        \r\n        & li{           \r\n          margin-left: 0px;\r\n          width:92%;\r\n        }\r\n        \r\n      }\r\n\r\n     & p{\r\n\r\n        text-align: left;\r\n        width:99%;\r\n     }\r\n     & table{\r\n    \r\n      \r\n       margin-left: 15px;\r\n       margin-top: -40px;\r\n       text-align: left;\r\n       border: 1px solid ;\r\n       border-collapse: collapse;\r\n       border-color: #764CBF;      \r\n      \r\n       & th {\r\n           margin-left: 40px;\r\n           text-align: left;\r\n           border: 0px solid;\r\n           background-color: #764CBF;\r\n           color:white;\r\n          padding-left: 5px;\r\n       }\r\n       & tr {\r\n           padding-left: 15px; \r\n           border: 1px solid;\r\n           border-color: #764CBF;\r\n           background-color: white\r\n           ;\r\n       } \r\n\r\n   }\r\n\r\n}\r\n\r\n.faq {\r\n\r\n    width:90%;\r\n    font-family: sans-serif;\r\n    overflow-y: scroll;\r\n    text-align: left;\r\n    & h1{\r\n\r\n        color: #5C2D91;\r\n        font-size: 5vw;\r\n        @media screen and (min-width: 769px)  and (max-width: 999px){\r\n            font-size:1.2rem;\r\n           }\r\n           @media screen and (min-width: 1000px)  and (max-width: 1200px){\r\n            font-size:1.3rem;\r\n           }\r\n          \r\n           @media screen and (min-width: 1201px)  and (max-width: 1580px){\r\n            font-size:1.6rem;\r\n           }\r\n           @media screen and (min-width: 1581px)  {\r\n            font-size:1.7rem;\r\n           }\r\n        \r\n    }\r\n    & h2{\r\n\r\n        text-align: left;\r\n        font-size: 4vw;\r\n        @media screen and (min-width: 769px)  and (max-width: 999px){\r\n            font-size:1rem;\r\n           }\r\n           @media screen and (min-width: 1000px)  and (max-width: 1200px){\r\n            font-size:1.2rem;\r\n           }\r\n          \r\n           @media screen and (min-width: 1201px)  and (max-width: 1580px){\r\n            font-size:1.3rem;\r\n           }\r\n           @media screen and (min-width: 1581px)  {\r\n            font-size:1.5rem;\r\n           }\r\n    }\r\n    & p{\r\n        text-align: left;       \r\n        margin-left:0;\r\n      \r\n        @media screen and (min-width: 769px)  and (max-width: 999px){\r\n            font-size:0.9rem;\r\n           }\r\n           @media screen and (min-width: 1000px)  and (max-width: 1200px){\r\n            font-size:1rem;\r\n           }\r\n          \r\n           @media screen and (min-width: 1201px)  and (max-width: 1580px){\r\n            font-size:1.1rem;\r\n           }\r\n           @media screen and (min-width: 1581px)  {\r\n            font-size:1.2rem;\r\n           }\r\n        \r\n    }\r\n    & ul{\r\n\r\n        text-align: left;\r\n    }\r\n}\r\n\r\n.paia{\r\n    width:90%;\r\n    font-family: sans-serif;\r\n    overflow-y: scroll;\r\n    & h4 {\r\n\r\n        color: #764CBF;\r\n    }\r\n\r\n    & p {\r\n\r\n        margin-left:10px;\r\n        text-align: left;\r\n        \r\n    }\r\n    & table,tr {\r\n     \r\n        border: 1px solid ;\r\n        border-color: #764CBF;\r\n        border-collapse: collapse;\r\n        background-color: white;\r\n        text-align: left;\r\n        width:100%;\r\n        & td{\r\n\r\n            border: 1px solid ;\r\n            border-color: #764CBF;\r\n            border-collapse: collapse;\r\n            background-color: white;\r\n            padding-right: 6px;\r\n        }       \r\n    }\r\n    & ul{\r\n\r\n        text-align: left;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
